import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const esetProtect = defineConnector({
  identifier: "esetProtect",
  name: "ESET PROTECT",
  tagLine: "Endpoint protection and EDR",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () =>
    "https://[a-z]+\\.(?:device-management|automation|incident-management)\\.eset\\.systems/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.region}.business-account.iam.eset.systems/oauth/token`,
        method: "POST",
        formBody: {
          grant_type: "password",
          username: app.secret.username,
          password: app.secret.password,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create an API user",
      items: [
        {
          kind: "markdown",
          content:
            "In ESET PROTECT (or ESET Business Account), create an API user account — only a Root or Superuser administrator can do this. ESET Connect authenticates with this API user's login and password. See the [ESET Connect docs](https://help.eset.com/eset_connect/en-US/authentication.html).",
        },
      ],
    },
    {
      title: "Enter your details",
      items: [
        {
          kind: "select",
          label: "Region",
          required: true,
          defaultValue: "eu",
          target: { kind: "configuration", field: "region" },
          options: [
            { value: "eu", label: "Europe" },
            { value: "de", label: "Germany" },
            { value: "us", label: "United States" },
            { value: "ca", label: "Canada" },
            { value: "jpn", label: "Japan" },
          ],
        },
        {
          kind: "input",
          label: "API user login",
          required: true,
          target: { kind: "secrets", field: "username" },
        },
        {
          kind: "input",
          label: "API user password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ region }) =>
      `https://${region}.device-management.eset.systems/v1/device_groups?pageSize=1`,
  },
});
